export const replaceParamsByModel = (url, model) => {
  const matches = url.match(/[{]([a-z_]+)[}]/g)
  
  if (matches) {
	  const fields = matches.map(str => str.replace(/[{}]/g,''))

	  fields.forEach(field => {
		url = url.replace(new RegExp(`[{]${field}[}]`), model[field])
	  })
  }
  
  return url
};